import React from "react";

import OrdersController, {
  Props,
  configJSON,
  // Customizable Area Start
  Option,
  IMobileServiceRequest,
  IAssignableDriver,
  // Customizable Area End
} from "./OrdersController.web";

// Customizable Area Start

import {
  Paper,
  TableRow as MuiTableRow,
  TableHead,
  TableContainer,
  TableCell as MuiTableCell,
  TableBody,
  Table,
  Box,
  Select,
  MenuItem,
  FormControl,
  styled,
  Snackbar,
  TablePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  AppBar,
  Tabs,
  Tab,
  MenuProps,
  Radio,
  StyledComponentProps,
  CircularProgress,
  Portal,
  Grid,
  Typography,
  TextareaAutosize,
  Button,
  Tooltip,
  IconButton,
  Chip,
  Collapse,
  Popover
} from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CloseIcon from "@material-ui/icons/Close";
import NavigationIcon from "@material-ui/icons/Navigation";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Alert } from "@material-ui/lab";
import '../../../blocks/categoriessubcategories/src/PreferenceList.css'
import {
  withStyles
} from "@material-ui/core/styles";
import FilterIcon from "@material-ui/icons/FilterList";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import DropdownRadio from "../../../components/src/customComponents/DropdownRadio.web";
import PageContainer from "../../../blocks/navigationmenu/src/PageContainer.web";
import FilterPopover,  { IFilter }  from "../../../components/src/FilterPopover";
import SortingTableHeader from "../../../components/src/SortingTableHeader2";
import SortingTableCell from "../../../components/src/SortingTableCell";

import {
  editIcon,
  printIcon,
  circleIcon,
  iconUnpaidGray,
  iconPrinterGray,
  radio_blue,
  radio_white,
} from "./assets";

import {
  CustomTabs,
  CustomTab,
} from "../../../components/src/customComponents/CustomTags.web";

import OrderDetailsPage from "./OrderDetails.web";
import PrintModal from "./PrintModal.web";

import {
  SubmitButton,
  CancelButton,
  ButtonContainer,
  RoundedDialog,
} from "../../../components/src/CustomTheme.web";

import { BottomContainer } from "../../promocodes/src/PromoCodeCreate.web";
import BarcodesScanner from "../../BarcodesScanner/src/BarcodesScanner.web";
import { showNotes } from "../../advancedsearch/src/AdvancedSearch.web";
import PaymentModal from "../../Payments/src/PaymentModal.web";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
import { ISortingData } from "../../../components/src/SortingTableHeader";
import { IOrderData } from "./OrderDetailsController.web";
const Strings = configJSON.ListingPage.Strings;
const CheckTrue = require("../../../components/src/check_true.svg");
const CheckFalse = require("../../../components/src/check_false.svg");
import { colors } from "../../utilities/src/Colors";
import {
  TableRow as TableRownew,
  TableCell as TableCellnew,
  OrderTable,
  RowContainer,
} from "../../../components/src/OrderTable/src";
import { conditionalString, renderBaseOnConditions, renderBooleanConditions, sortStringCondition } from "../../../blocks/utilities/src/CustomBlockHelpers";
import { CustomSnackbar } from "../../../components/src/customComponents/CustomSnackbar.web";
import ConfirmationDialog from "../../../components/src/customComponents/ConfirmationDialog.web";
import { IOrder } from "../../OrderCreation/src/OrderCreation2Controller.web";
import { IconBluePrint, creditNoteIcon } from "../../../blocks/cfplantdashboard2/src/assets";
import { CreditNoteInput, MainWrapper, PriceGrid, StyledDialogWrapper, StyledSelectAdjustmentReason, TextLabel } from "../../../blocks/cfplantdashboard2/src/Cfplantdashboard2.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { CustomMenuProps } from "../../ProductDescription/src/HomeCleaningSettingsList.web";
const IconSortingUp = require("../../../components/src/assets/sort/sort top.png");
const IconSortingNormal = require("../../../components/src/assets/sort/sort.png");
const IconSortingDown = require("../../../components/src/assets/sort/sort down.png");
// Customizable Area End

// Coming to Store grid: Request, Placed, Customer, Notes, Pickup, Service, Status, Action
const MOBILE_REQUEST_COLUMNS = "1.25fr 1.5fr 1.75fr 1.5fr 1.5fr 1fr 1fr 1fr";

// Coming to Store rows carry one line per cell, so they can sit tighter than the
// shared OrderTable default (12px padding / 22px line-height).
const compactCell: React.CSSProperties = {
  padding: "6px 12px",
  fontSize: 14,
  lineHeight: "18px",
  alignItems: "center",
};

export default class Orders extends OrdersController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  // Helper method to convert hex color to rgba
  hexToRgba = (hex: string | null | undefined, opacity: number): string => {
    if (!hex) {
      // Fallback color - light orange
      return `rgba(255, 152, 0, ${opacity})`;
    }

    // Remove # if present
    hex = hex.replace('#', '');

    // Parse hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  getOrderDetails(rowData: IOrderData): string | React.ReactNode {
    if (rowData.attributes?.order_items.length === 0) return "--";
    if (rowData.attributes?.is_quick_drop)
      return rowData.attributes?.order_items[0]?.qty;
    else
      return (
        <div>
          {rowData.attributes?.order_items.slice(0, 2).map((orderItem: any, index: number) => {
            return (
              <>
                {rowData.type == "home_cleaning_order" ?
                  <div key={orderItem.id + index} style={{display:"flex",flexWrap:"wrap"}}>
                    <span style={{
                      color: orderItem.attributes.promotional_info?.is_free_item 
                        ? '#059669' 
                        : 'inherit'
                    }}>
                      {orderItem.attributes.catalogue.name}
                    </span>
                    <img src={circleIcon} alt='product' />
                    <span style={{
                      color: orderItem.attributes.promotional_info?.is_free_item 
                        ? '#059669' 
                        : 'inherit'
                    }}>
                      {orderItem.attributes.catalogue.second_name}
                    </span> (
                    {orderItem.attributes.product_type.name || "--"}) x {orderItem.attributes.quantity}
                  </div> :
                  <div key={orderItem.name + index} style={{display:"flex",flexWrap:"wrap"}}>
                   <span style={{
                     color: orderItem.promotional_info?.is_free_item 
                       ? '#059669' 
                       : 'inherit'
                   }}>{orderItem.name}</span> <img src={circleIcon} alt='circle' /> 
                   <span style={{
                     color: orderItem.promotional_info?.is_free_item 
                       ? '#059669' 
                       : 'inherit'
                   }}>{orderItem.second_name}</span> (
                    {orderItem.service_short_name || "--"}) x {orderItem.qty}
                    {rowData.attributes.order_type !== "GoldenPointsOrder" && (
                    <div style={{ color: "#0F172A", fontSize: "12px",fontWeight: "400", textTransform: "lowercase"}}>
                      {Number(orderItem?.height) !== 0 && Number(orderItem?.width) !== 0  && (<>length * width: <div> {orderItem.height} m * {orderItem.width} m </div></>)}
                      {Number(orderItem?.weight) !== 0 && (<>weight : {orderItem.weight} Kg</>)}
                    </div>
                    )}
                  </div>}
              </>
            );
          })}
          {
            renderBaseOnConditions(
              renderBooleanConditions(
                rowData.attributes.order_type === "B2bOrder",
                Boolean(this.state.b2bPermissionStatus.viewOrderPermission),
                this.state.permissionStatus.viewOrderPermission
              )
              ,
              <div style={{ paddingTop: 12 }}>
                <div
                  data-test-id={`detail${rowData.id}`}
                  className="detailsBtn"
                  onClick={() => this.handleOrderDetail(rowData)}
                >
                  Details
                </div>
              </div>,
              <></>
            )
          }
        </div>
      );
  }

  renderOrderNumber = (orderNumber: string, orderType: string) => {
    return(
      <>
      <div style={{display: "flex", justifyContent: "space-between", flexDirection: "column", gap: "2"}}>
        <div>{orderNumber}</div>
        <div style={{paddingTop: "12px"}}>{orderType === "B2bOrder" && <StatusButton>B2b</StatusButton>}</div>
      </div>
      </>
    )
  }

  renderOrderUnpaidDialog() {
    return (
      <RoundedDialog
        data-test-id='unpaidOrderModal'
        open={this.state.unpaidDialogPopup}
      >
        <DialogContent>
          <Snackbar
            data-test-id='message-unpaid'
            autoHideDuration={5000}
            key={"unpaid-order-error-snackbar"}
            open={this.state.unPaidOrderError.length > 0}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={this.hideUnpaidOrderError.bind(this)}
          >
            <Alert
              onClose={this.hideUnpaidOrderError.bind(this)}
              severity={"error"}
            >
              {this.state.unPaidOrderError}
            </Alert>
          </Snackbar>
          <img className="mainIcon" src={iconUnpaidGray} />
          <h3>{Strings.orderUnPaid}</h3>
          <p style={webStyle.unPaidDialogPara}>
            {Strings.orderUnpaidDiaglogPara}
          </p>
          <ButtonContainer justifyContent={"center"}>
            <CancelButton data-test-id="unpaidOrderModalClose" onClick={this.closeUnpaidDialog}>Cancel</CancelButton>
            <SubmitButton
              data-test-id='unpaidOrderModalPay'
              onClick={this.handleDeliverPaymentModalOpen}
            >
              Pay Now
            </SubmitButton>
          </ButtonContainer>
        </DialogContent>
      </RoundedDialog>
    );
  }

  ordersTableHeaderRender(sortingData: ISortingData) {
    return (
      <RowContainer header>
        <TableRownew
          className='table-cols'
          columns = {"1.25fr 1.25fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1.50fr" + conditionalString(this.state.selectedDropdownvalue, ' 1fr', '')}
        >
          {
            this.getConditionBased(
              this.state.showCheckBoxAndButton,
              <TableCellnew
                header
                className='align-item-center'
                content={
                  <img
                    style={{ cursor: "pointer" }}
                    data-test-id='selectAll'
                    onClick={() => this.handleSelectAll()}
                    src={this.getConditionBased(this.state.selectAllChecked,CheckTrue,CheckFalse) as string}
                    alt={this.getConditionBased(this.state.selectAllChecked,"checked","unchecked") as string}
                  />
                }
              />,
              <></>
            )
          }
          {
            this.getConditionBased(
              this.state.selectedDropdownvalue === "rewash",
              <TableCellnew
                header
                className='align-item-center'
                content={
                  <img
                    style={{ opacity: 0 }}
                    data-test-id='selectAll'
                    src={this.getConditionBased(this.state.selectAllChecked,CheckTrue,CheckFalse) as string}
                    alt={this.getConditionBased(this.state.selectAllChecked,"checked","unchecked") as string}
                  />
                }
              />,
              <></>
            )
          }
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.orderId}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'order_number'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.placedDate}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'created_at'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.customer}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'customer'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.contact}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'full_phone_number'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.order}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.pcs}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.notes}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.paid}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.total}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'total'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.status}
            className='align-item-center'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'internal_status'}
            sortingDisabled={false}
            {...this.sortingProps}
          />
        </TableRownew>
      </RowContainer>
    )
  }

  sendToDriverTableHeaderRender(sortingData: ISortingData, rows: IOrderData[]) {
    const hiddenOrders = rows.filter(
      (item: IOrderData) => item.attributes.is_quick_drop
    ).length;

    const condition1 =
      rows.length - hiddenOrders === this.state.selectedOrders.length;
    const isAllSelected = condition1 && this.state.selectedOrders.length > 0;

    return (
      <RowContainer header>
        <TableRownew
          className='table-cols'
          columns={'0.5fr 1fr 0.7fr 1fr 1fr 1fr'}
        >
          <TableCellnew
            header
            content={
              <SelectAllContainer>
                <StyledImageCheckbox
                  src={this.getConditionBased(isAllSelected,CheckTrue,CheckFalse) as string}
                  data-test-id='field-selectAll'
                  onClick={() => this.onSelectAllSendToDriver(rows)}
                />
                <div>All</div>
              </SelectAllContainer>
            }
            className='align-item-center'
            type='left'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content='ID'
            type='middle'
            sortingDisabled
            {...this.sortingProps}
          />

          <TableCellnew
            header
            content='Pieces'
            sortingDisabled
            {...this.sortingProps}
          />

          <TableCellnew
            header
            content='Order#'
            type='middle'
            sortingDisabled
            {...this.sortingProps}
          />

          <TableCellnew
            header
            content='Customer'
            sortingIcons={[
              IconSortingNormal,
              IconSortingUp,
              IconSortingDown,
            ]}
            sortingKey={'customer'}
            sortingDisabled={false}
            {...this.sortingProps}
          />

          <TableCellnew
            header
            content='Notes'
            sortingDisabled
            {...this.sortingProps}
          />
        </TableRownew>
      </RowContainer>
    )
  }

  renderSendToDriverTableBody(rows: IOrderData[]) {
    return (
      <RowContainer>
        {rows.map((rowData: IOrderData, index: number) => {
          if (rowData.attributes.is_quick_drop) return <></>;

          return (
            <TableRownew
              key={index + "TableRow"}
              className='table-rows'
              columns={"0.5fr 1fr 0.7fr 1fr 1fr 1fr"}
            >
              <TableCellnew
                type='left'
                content={
                  <div style={{paddingLeft: 9}}> 
                    <StyledImageCheckbox
                      src={this.getConditionBased(this.checkIsOrderSelect(rowData),CheckTrue,CheckFalse) as string}
                      data-test-id={`singleCheckbox${index}`}
                      onClick={() => this.onSelectOrder(rowData)} 
                    />
                  </div>
                }
              />

              <TableCellnew
                type='middle'
                content={this.renderOrderNumber(rowData.attributes?.order_number, rowData.attributes?.order_type)}
              />

              <TableCellnew
                type='middle'
                content={rowData.attributes?.total_pieces}
              />

              <TableCellnew
                type='middle'
                content={this.getOrderDetails(rowData)}
              />

              <TableCellnew
                type='middle'
                content={rowData.attributes?.customer?.full_name || "--"}
              />

              <TableCellnew
                type='right'
                content={
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {showNotes(rowData.attributes?.notes)}
                    <Button
                      style={{
                        minWidth: '24px',
                        width: '24px',
                        height: '24px',
                        padding: '0',
                        fontSize: '16px',
                        lineHeight: '1',
                        borderRadius: '4px'
                      }}
                      variant="outlined"
                      color="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleOpenNotesDialog(rowData.id, rowData.attributes?.notes);
                      }}
                    >
                      +
                    </Button>
                  </div>
                }
              />
            </TableRownew>
          );
        })}
      </RowContainer>
    )
  }

  
  showDateCreatedRender = (created_at: string,rowData: IOrderData) => {
    if(created_at){
      return (
        <div>
          <div>
            {this.handleMomentDateFormat(created_at, "DD/MM/YYYY")}
          </div>
          <div>
            {this.handleMomentDateFormat(created_at, "h:mm A")}
          </div>
          <div>
            {rowData.attributes.order_created_by?.first_name}
          </div>
        </div>
        
      )
    }
  }

  showPaidDetails = (rowData: IOrderData) => {
    const isPaidAt = rowData.attributes.paid_at ? true : false
   return (
    <div>
    <div data-test-id='paid-details'>
      {(rowData.attributes?.[rowData.attributes?.paid ? 'paid' : 'order_transactions'] || [])
      .map(
        (object) =>
          `${object.name} ${this.handleMomentDateFormat(object.latest_created_at, "DD/MM/YYYY") +' '+this.handleMomentDateFormat(object.latest_created_at, "h:mm A")} ${conditionalString(object.received_by, ','+object.received_by, '')}`
      )
      .join(", ") || "---"}</div>

  </div>
   )
  }

  showStatusDetails = (internal_status:string,rowData: IOrderData) => {
    if(internal_status.toLowerCase() !=='delivered' && internal_status.toLowerCase() !== 'cancelled' )
      { return  <div>
        {internal_status}
      </div>}
    else {
    const { by, at } = rowData.attributes.action_by_time_detail;
    const isPaidAt = at ? true : false
   return (
    <div>
     <div>
          {internal_status}
        </div>
      <div>
        {at && this.handleMomentDateFormat(at, "DD/MM/YYYY")}
    </div>
    <div>{at && this.handleMomentDateFormat(at, "h:mm A")}</div>    
    {
    renderBaseOnConditions(
        isPaidAt,
        <div>{by  ? by : ''}</div>,
        <></>
      )
    }
  </div>
   )
  }
  }

  labelByPaymentType(paymentType:IOrderData)
  {
    if(paymentType.attributes.paid.length ==1 && paymentType.attributes.paid[0].payment_type=='Pay Later')
    {
      return 'Unpaid'
    }
    else
      return 'Partially paid'
  }

  renderOrderTableBody(rows: IOrderData[]) {
    return (
      <RowContainer>
        {rows.map((rowData: IOrderData, index: number) => {
          const isEditable = !Boolean(rowData.attributes.send_to_zatca);
          const { paid_at, internal_status, is_quick_drop } = rowData.attributes;
          const isRedeemReceipt= rowData.attributes.is_redeem_receipt
          const payStatusData = { color: '#DC2626', label: this.labelByPaymentType(rowData), component: <CustomRadioUnpaid
          checked
        /> }
          if(!is_quick_drop && paid_at) {
            payStatusData.color = '#059669'
            payStatusData.label = 'Paid'
            payStatusData.component = <CustomRadioPaid
            checked
          />
          }

          // Check if this is a late delivery B2C order
          const isLateDeliveryB2C =
            rowData.attributes.late_delivery_order === true &&
            rowData.attributes.order_type !== "B2bOrder";

          // Get background color for late delivery
          const rowBackgroundColor = isLateDeliveryB2C
            ? this.hexToRgba(rowData.attributes.colorcode, 0.1)
            : 'transparent';

          return (
            <React.Fragment key={"orders-mangement" + index}>
              <TableRownew
                className='table-rows'
                columns={"1.25fr 1.25fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1.50fr" + conditionalString(this.state.selectedDropdownvalue, ' 1fr', '')}
                data-test-id ="table-rows"
                style={{
                  backgroundColor: rowBackgroundColor
                }}
              >
                {
                  this.getConditionBased(
                    this.state.showCheckBoxAndButton,
                    <TableCellnew 
                      type='left'
                      className='pl-0 align-self-center'
                      content={
                        <>         
                        <img
                          style={{ cursor: "pointer", border: "1px solid #64748B",
                            borderRadius: "6px" }}
                          data-test-id={`singleCheckbox${index}`}
                          onClick={() =>
                            this.handleSingleCheck(rowData.id)
                          }
                          alt={this.getConditionBased(rowData.checked as boolean,"checked","unchecked") as string}
                          src={this.getConditionBased(rowData.checked as boolean,CheckTrue,CheckFalse) as string}
                        />
                        </>
                      }
                    />,
                    <></>
                  )
                }
                {
                  this.getConditionBased(
                    this.state.selectedDropdownvalue === "rewash",
                    <TableCellnew
                      type='none'
                      className='pl-0 align-self-center'
                      content={
                        <img
                          style={{ cursor: "pointer" }}
                          data-test-id={`singleRadioButton${index}`}
                          onClick={() =>
                            this.handleSelectOrderToRewash(rowData.id)
                          }
                          src={this.getConditionBased(rowData.checked as boolean,radio_blue,radio_white) as string}
                          alt={this.getConditionBased(rowData.checked as boolean,'checked','unchecked') as string}
                        />
                      }
                    />,
                    <></>
                  )
                }
                <TableCellnew
                  content={<Box className="orderIdColumn">
                    <Box style={{ wordBreak: "break-all" }}>
                      {rowData.attributes?.order_number}
                    </Box>
                    {rowData.attributes?.order_type === "B2bOrder" && 
                    <Box style={{ wordBreak: "break-all", textAlign: "center"}}>
                      <StatusButton>B2b</StatusButton>
                    </Box>
                    }
                   {
                    configJSON.payBtnTabs.includes(internal_status) && (
                      <>
                        {isRedeemReceipt ? (
                          paid_at && (
                            <StatusDiv>
                              <CustomRadioPaid checked />
                              <Box
                                className="labelPaidUnpaid"
                                style={{ color: "#059669" }}
                              >
                                Paid
                              </Box>
                            </StatusDiv>
                          )
                        ) : (
                          <StatusDiv>
                            {payStatusData.component}
                            <Box
                              className="labelPaidUnpaid"
                              style={{ color: payStatusData.color }}
                            >
                              {payStatusData.label}
                            </Box>

                            {isLateDeliveryB2C && (
                              <Tooltip
                                title={`Late Delivery${
                                  rowData.attributes.late_delivery_hours
                                    ? `: ${rowData.attributes.late_delivery_hours} hours`
                                    : ""
                                }`}
                                arrow
                              >
                                <AccessTimeIcon
                                  style={{
                                    fontSize: "18px",
                                    color: rowData.attributes.colorcode || "#FF9800",
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </StatusDiv>
                        )}
                      </>
                    )
                  }
                  </Box>}
                  type={conditionalString(this.state.selectedDropdownvalue, 'middle', 'left') as 'middle' | 'left'}
                />
                <TableCellnew
                  dataid={configJSON.placedDateTest}
                  style={{ wordBreak: "break-word" }}
                  content={
                    this.showDateCreatedRender(rowData.attributes.placed_at as string,rowData)
                  }
                  type={'middle'}
                />
                <TableCellnew
                  style={{ wordBreak: "break-all"}}
                  content={rowData.attributes?.customer?.full_name || "--"}
                  type={'middle'}
                />
                <TableCellnew
                  style={{ wordBreak: "break-all"}}
                  content={rowData.attributes?.customer?.full_phone_number || "--"}
                  type={'middle'}
                  className="phoneNumber"
                />
                <TableCellnew
                  content={this.getOrderDetails(rowData)}
                  type={'middle'}
                />
                <TableCellnew
                  style={{ wordBreak: "break-all"}}
                  content={rowData.attributes?.total_pieces}
                  type={'middle'}
                  className="pcsCell"
                />
                <TableCellnew
                  style={{ wordBreak: "break-all" }}
                  content={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {showNotes(rowData.attributes?.notes)}
                      <Button
                        style={{
                          minWidth: '24px',
                          width: '24px',
                          height: '24px',
                          padding: '0',
                          fontSize: '16px',
                          lineHeight: '1',
                          borderRadius: '4px'
                        }}
                        variant="outlined"
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleOpenNotesDialog(rowData.id, rowData.attributes?.notes);
                        }}
                      >
                        +
                      </Button>
                    </div>
                  }
                  type={'middle'}
                />
                <TableCellnew
                  content={
                    this.showPaidDetails(rowData)
                  }
                  type={'middle'}
                />
                <TableCellnew
                  type='middle'
                  content={
                    <div className="columnContainer">
                      {renderBaseOnConditions(rowData.attributes.order_type === 'B2bOrder'
                        , <div className='total'>{Strings.dashPlaceholder}</div>
                        , <div className='total'>{rowData.attributes.currency}{' '}
                          {rowData.attributes?.total || "--"}
                        </div>)}
                      {this.getStatusOfOrder(rowData.attributes?.internal_status) != "" &&
                        <div style={webStyle.ButtonGroup as React.CSSProperties}>
                          {rowData.attributes?.internal_status == 'ready' && <StatusButton
                            data-test-id={`statusBtn-rewash`}
                            onClick={() => this.handleStatusChange({ ...rowData, attributes: { ...rowData.attributes, internal_status: 'delivered' } })}
                          >
                            {this.getStatusOfOrder('delivered')}
                          </StatusButton>}
                          {
                            renderBaseOnConditions(
                              rowData.attributes?.internal_status == "cleaning",
                              renderBaseOnConditions(
                                rowData.attributes?.status_plant == "dispatched" &&
                                rowData.attributes.status == "placed",
                                <StatusButton
                                  data-test-id={`statusBtn-${rowData.attributes?.id}`}
                                  onClick={() => this.handleStatusChange(rowData)}
                                >
                                  {this.getStatusOfOrder("cleaning")}
                                </StatusButton>,
                                <></>
                              ),
                              <StatusButton
                                  data-test-id={`statusBtn-${rowData.attributes?.id}`}
                                  onClick={() => this.handleStatusChange(rowData)}
                                >
                                  {this.getStatusOfOrder(rowData.attributes?.internal_status)}
                              </StatusButton>
                            )
                          }
                        </div>
                      }
                    </div>
                  }
                />
                <TableCellnew
                  type="right"
                  content={
                    <div className="columnContainer">
                    <div style={webStyle.StatusSpan as React.CSSProperties} className="order">
                        {this.showStatusDetails(this.showStatusOnOrder(rowData), rowData)}

                        {rowData.attributes.status === "cancelled" && (
                          <div className="cancelledDetails">
                            <div className="cancelledBy">
                              {rowData.attributes.cancelled_by || "--"}
                            </div>

                            <div className="cancelledAt">
                              {rowData.attributes.cancelled_at
                                ? this.showDateCreatedRender(
                                    rowData.attributes.cancelled_at,
                                    rowData
                                  )
                                : "--"}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="statusColumnAction">
                        
                        { !isRedeemReceipt && paid_at === null && !is_quick_drop && configJSON.payBtnTabs.includes(internal_status) && <StatusButton data-test-id="pay-btn" onClick={() => { this.handleDirectPaymentModalVisible(rowData)}}>Pay</StatusButton>}
                        {renderBaseOnConditions(
                          this.showEditOrderButton(rowData)
                          && isEditable 
                          && renderBooleanConditions(
                            rowData.attributes.order_type === "B2bOrder",
                            Boolean(this.state.b2bPermissionStatus.editOrderPermission),
                            this.state.permissionStatus.editOrderPermission
                          ),
                          <img
                           width={26}
                           height={26}
                            src={editIcon}
                            alt={"edit"}
                            data-test-id={`EditIcon-${rowData.id}`}
                            style={{
                              cursor: "pointer",
                              width: "26px",
                            }}
                            onClick={() =>
                              this.handleEditClick(
                                rowData
                              )
                            }
                          />, <></>
                        )}
                        {
                          renderBaseOnConditions(
                            this.showPrintButton(),
                            <img
                              width={26}
                              height={26}
                              src={printIcon}
                              alt={"print"}
                              style={{
                                cursor: "pointer",
                                width: "26px",
                              }}
                              data-test-id='btn-print'
                              onClick={() =>
                                this.openPrinterDialog(rowData)
                              }
                            />,
                            <></>
                          )
                        }
                        {!isRedeemReceipt && this.getCreditNoteButton(rowData)}
                      </div>
                    </div>
                  }
                />
              </TableRownew>
            </React.Fragment>
          );
        })}
      </RowContainer>
    )
  }

  getCreditNoteButton(item: IOrderData) {
    if (
      !item?.attributes?.credit_note
      ||
      !item?.attributes?.paid_at
    ) return <></>;
    const isCreditOrder = item.attributes.credit_order_at
    const { permissionStatus } = this.state;
    return (
      <>
      {renderBaseOnConditions(
        isCreditOrder !== null , 
        <>
        {permissionStatus.viewCreditOrderAccess && item.attributes.order_type !== "B2bOrder"&& <div>
        <div className='credit-note-show-button'>
         <button
          onClick={() => this.toggleCreditNoteDialog(item)}
          data-test-id={"credit-note-button-" + item.id}
        >
          <img src={creditNoteIcon} /><span style={{marginTop: "3px", fontSize:"10px"}}>{configJSON.credit_note_view_button}</span>
        </button>
      </div>
      </div>}
      </>
      ,
      <>
     {permissionStatus.createCreditNoteAccess && item.attributes.order_type !== "B2bOrder" &&  <div>
        <div className={'credit-note-button'}>
         <button
          onClick={() => this.toggleCreditNoteDialog(item)}
          data-test-id={"credit-note-button-" + item.id}
        >
          <img src={creditNoteIcon} /><span style={{marginTop: "3px"}}>{configJSON.credit_note_button}</span>
        </button>
      </div>
      </div>}
      
      </>)}
      </>
    );
  }


  renderCreditNoteDialog() {
    const {
      addNote,
      creditNoteOrder,
      isCreditNoteDialogOpen,
      isConfirmationChecked,
      creditNoteReceipt,
      openCrediNoteModalLoader,
      hidden
    } = this.state;

    const {
      adjustment_reason, adjustment_note,
      order_number,
      total_tax,
      sub_total,
      currency, total,
    } = creditNoteOrder?.attributes || {};
    
    return (
      <StyledDialogWrapper
        fullWidth
        maxWidth={"md"}
        data-test-id='dialog'
        className='mainDialog'
        open={isCreditNoteDialogOpen}
      >
        <Typography className='headerTitle' variant='h4' align='center'>
          {configJSON.stringsCreditNotePage_CreateCreditNoteHeader}
        </Typography>
        <CustomLoader loading={this.state.openCrediNoteModalLoader} />
        <DialogContent className='dialogContent'>
          <Box className="credit-note-modal-header">
            <Typography className='orderId'> Order ID : {this.renderCreditOrderNumber(order_number)}</Typography>
            {renderBaseOnConditions(
              hidden && !openCrediNoteModalLoader,
              <Typography className='orderId'> Reference ID : {order_number} </Typography>,
              <></>
            )}
          </Box>
          <TextLabel>
            {configJSON.stringsCreditNotePage_AdjustMentReason}
          </TextLabel>
          <StyledSelectAdjustmentReason
            variant='outlined'
            id='adjustmentReasonId'
            name='adjustmentReasonId'
            value={adjustment_reason}
            MenuProps={CustomMenuProps}
            data-test-id='adjustmentReasonId'
          >
            <MenuItem value={adjustment_reason || ""}>
              {adjustment_reason}
            </MenuItem>
          </StyledSelectAdjustmentReason>

          <br></br>
          <br></br>
          <Grid>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className='tableHeading' variant='h4'>
                {configJSON.stringsCreditNotePage_table_heading}
              </Typography>
              <button
                  disabled={!creditNoteReceipt}
                  className='printBtn'
                  data-test-id='btn-print-credit-note'
                  onClick={() => this.hanldeClickPrintCreditNote()}
              >
                <img src={IconBluePrint} />
                {configJSON.stringsListPage_print}
              </button>
            </Box>
            

            <br></br>
            {this.renderOrderDetailTable()}
          </Grid>

          <br></br>
          <br></br>

          <PriceGrid
            container
            direction='column'
            justifyContent='flex-end'
            alignItems='flex-end'
            className="total_price"
          >
            <Grid>
              Total : {currency} {sub_total}
            </Grid>
            <Grid> Tax : {currency} {total_tax}</Grid>
            <Grid>
              Total inc. Tax: {currency} {total}
            </Grid>
          </PriceGrid>

          <Typography className='adjustmentDetails' variant='h6'>
            {configJSON.stringsCreditNotePage_AdjustMentDetails}
          </Typography>
          <Typography className='addedNewUpcharge' variant='h6'>{adjustment_note}</Typography>
          <TextareaAutosize minRows={2}
            value={addNote}
            className='textAreaStyles'
            onChange={this.handleAddNote}
            data-test-id='creditNotTextInput'
            disabled={this.state.creditNotePresent}
            placeholder={configJSON.stringsCreditNotePage_CreditNote_Add_Note}
          />
        </DialogContent>

        <div className='confirm-text-container'>
          <img
            alt='checkbox'
            data-test-id='confirmationBox'
            onClick={this.handleConfirmationCheckBox}
            src={isConfirmationChecked ? CheckTrue : CheckFalse}
          />
          <span className='confirmationText'>
            {configJSON.stringsCreditNotePage_ConfirmationText}
          </span>
        </div>

        <Box className='groupButton'>
          <Grid container direction='row' spacing={1}>
            <Grid item xs={12} md={6}>
              <Button disableRipple
                className='cancelButton'
                data-test-id='cancel-btn-customer-preference'
                onClick={() => this.toggleCreditNoteDialog()}
              >
                {configJSON.stringsCreditNotePage_CancelButton}
              </Button>
            </Grid>
            {this.state.hidden === false && (
              <Grid item xs={12} md={6}>
                <Button disableRipple
                  className='addButton'
                  onClick={() => this.createCreditNoteApiCall()}
                  disabled={!this.state.isConfirmationChecked || this.state.creditLoader}
                  data-test-id='create-button-customer-preference'
                >
                 {this.state.creditLoader ?
                  <CircularProgress style={{ width: 24, height: 24, color: "white" }} />
                  :
                  configJSON.stringsCreditNotePage_CreateCreditNoteButton
                }
                  
                </Button>
              </Grid>
             )} 
          </Grid>
        </Box>
      </StyledDialogWrapper>
    );
  }


  renderCreditOrderNumber = (order_number: string | undefined) => {
    const { hidden, creditNoteOrderNumber, openCrediNoteModalLoader } = this.state;
    if(openCrediNoteModalLoader) {
      return "";
    } else {
      if(!hidden) {
        return order_number;
      } else {
        return creditNoteOrderNumber;
      }
    }
  };

  renderOrderDetailTable() {
    const { customer, currency, created_at, total, tax_percentage } =
      this.state.creditNoteOrder?.attributes || {};

    return (
      <>
      <MainWrapper>
        <TableContainer component={Paper}>
          <Table aria-label='customized table'>
            <TableHead>
              <MuiTableRow className='tableheaderRow'
                style={{ color: colors().background, background: "#F8FAFC" }}
              >
                <MuiTableCell className="tableHeader">Customer Name</MuiTableCell>
                <MuiTableCell className="tableHeader">Order Creation Date</MuiTableCell>
                <MuiTableCell className="tableHeader">Total Order Amount</MuiTableCell>
                <MuiTableCell className="tableHeader">Tax</MuiTableCell>
                <MuiTableCell className="tableHeader">Adjustment Amount</MuiTableCell>
                <MuiTableCell className="tableHeader">Refund Amount</MuiTableCell>
              </MuiTableRow>
            </TableHead>
            <TableBody data-test-id='tblBody'>
              <MuiTableRow>
                <MuiTableCell>
                  {customer?.full_name}
                </MuiTableCell>
                <MuiTableCell>
                  {this.getMomentFormat(String(created_at))}
                </MuiTableCell>
                <MuiTableCell>{total}</MuiTableCell>
                <MuiTableCell>
                  <CreditNoteInput
                    value={`${tax_percentage} %`}
                    className='tax' readOnly
                  />
                </MuiTableCell>
                <MuiTableCell>
                  <CreditNoteInput
                    value={currency + " " + total}
                    className='amount'
                    readOnly
                  />
                </MuiTableCell>
                <MuiTableCell>{currency + " " + total}</MuiTableCell>
              </MuiTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </MainWrapper>
      </>
    );
  }

  renderMobileRequestDetailDialog() {
    const { mobileRequestDetailOpen, mobileRequestDetailData, mobileRequestDetailLoading } = this.state;
    const attrs = mobileRequestDetailData?.attributes;
    // A request can carry more than one order; fall back to the legacy single `order` key
    const requestOrders: any[] = Array.isArray(attrs?.orders) && attrs.orders.length > 0
      ? attrs.orders
      : (attrs?.order ? [attrs.order] : []);
    const ordersSummary = attrs?.orders_summary;

    const renderAddress = (label: string, address: any) => {
      if (!address) return null;
      return (
        <Grid item xs={12}>
          <MobileDetailLabel>{label}</MobileDetailLabel>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <MobileDetailValue>
              {address.label} - {address.address}{address.location ? `, ${address.location}` : ""}
            </MobileDetailValue>
            {(address.latitude && address.longitude) && (
              <Button
                data-test-id={`${label.toLowerCase().replace(/\s/g, '')}MapBtn`}
                variant="outlined"
                size="small"
                startIcon={<NavigationIcon />}
                onClick={() => this.openMapNavigation(address.latitude, address.longitude)}
                style={{ borderColor: "#204B9C", color: "#204B9C", textTransform: "none", fontFamily: "Montserrat", fontWeight: 600 }}
              >
                Map
              </Button>
            )}
          </Box>
        </Grid>
      );
    };

    // The server owns the rule (store_can_edit): open until the driver sends the
    // order to the customer, and again if they reject it. An invoiced order is
    // past editing whatever the request says.
    const canEditOrder = (order: any) =>
      ordersSummary?.store_can_edit === true && order.in_cart !== false && !order.paid_at;

    const renderOrderCard = (order: any) => (
      <Grid item xs={12} key={order.id} data-test-id={`mobileRequestOrder-${order.id}`}>
        <Box style={{ border: "1px solid #E5E7EB", borderRadius: 8, padding: 16 }}>
          {canEditOrder(order) ? (
            <Box display="flex" justifyContent="flex-end" style={{ marginBottom: 8 }}>
              <Button
                data-test-id={`editMobileOrderBtn-${order.id}`}
                variant="outlined"
                size="small"
                onClick={() => this.navigateToEditMobileOrder(order.id)}
                style={{ borderColor: "#204B9C", color: "#204B9C", textTransform: "none", fontFamily: "Montserrat", fontWeight: 600 }}
              >
                Edit Items
              </Button>
            </Box>
          ) : ordersSummary?.approval_pending ? (
            <Box data-test-id={`mobileOrderLocked-${order.id}`} style={{ marginBottom: 8, fontFamily: "Montserrat", fontSize: 13, color: "#6B7280" }}>
              With the customer for approval — items can't be edited until they respond.
            </Box>
          ) : null}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MobileDetailLabel>Order Number</MobileDetailLabel>
              <MobileDetailValue>{order.order_number || "--"}</MobileDetailValue>
            </Grid>
            <Grid item xs={6}>
              <MobileDetailLabel>Order Status</MobileDetailLabel>
              <MobileDetailValue>{this.formatMobileRequestStatus(order.internal_status || order.status || "--")}</MobileDetailValue>
            </Grid>
            <Grid item xs={4}>
              <MobileDetailLabel>Total</MobileDetailLabel>
              <MobileDetailValue>{order.total || "--"}</MobileDetailValue>
            </Grid>
            <Grid item xs={4}>
              <MobileDetailLabel>Sub Total</MobileDetailLabel>
              <MobileDetailValue>{order.sub_total || "--"}</MobileDetailValue>
            </Grid>
            <Grid item xs={4}>
              <MobileDetailLabel>Tax</MobileDetailLabel>
              <MobileDetailValue>{order.total_tax || "--"}</MobileDetailValue>
            </Grid>
            {order.order_items && order.order_items.length > 0 && (
              <Grid item xs={12}>
                <MobileDetailLabel>Order Items</MobileDetailLabel>
                <TableContainer component={Paper} style={{ marginTop: 8 }}>
                  <Table size="small">
                    <TableHead>
                      <MuiTableRow style={{ background: "#204B9C" }}>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Item</MuiTableCell>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Service</MuiTableCell>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Qty</MuiTableCell>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Unit Price</MuiTableCell>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Total</MuiTableCell>
                        <MuiTableCell style={{ color: "#FFF", fontWeight: 600, fontFamily: "Montserrat" }}>Status</MuiTableCell>
                      </MuiTableRow>
                    </TableHead>
                    <TableBody>
                      {order.order_items.map((item: any) => (
                        <MuiTableRow key={item.id}>
                          <MuiTableCell>{item.catalogue_name}</MuiTableCell>
                          <MuiTableCell>{item.service_name}</MuiTableCell>
                          <MuiTableCell>{item.quantity}</MuiTableCell>
                          <MuiTableCell>{item.unit_price}</MuiTableCell>
                          <MuiTableCell>{item.total_price}</MuiTableCell>
                          <MuiTableCell>{this.formatMobileRequestStatus(item.status || "--")}</MuiTableCell>
                        </MuiTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
    );

    return (
      <Dialog
        open={mobileRequestDetailOpen}
        onClose={this.closeMobileRequestDetail}
        maxWidth="md"
        fullWidth
        data-test-id="mobileRequestDetailDialog"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography style={{ fontFamily: "Montserrat", fontSize: 20, fontWeight: 600 }}>
              Request Details {attrs ? `- ${attrs.request_number}` : ""}
            </Typography>
            <IconButton onClick={this.closeMobileRequestDetail} data-test-id="closeDetailBtn">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {mobileRequestDetailLoading ? (
            <Box display="flex" justifyContent="center" padding={4}>
              <CircularProgress />
            </Box>
          ) : attrs ? (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <MobileDetailLabel>Request Number</MobileDetailLabel>
                <MobileDetailValue>{attrs.request_number}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Status</MobileDetailLabel>
                <Chip
                  label={this.formatMobileRequestStatus(attrs.status)}
                  style={{
                    backgroundColor: this.getMobileStatusColor(attrs.status).bg,
                    color: this.getMobileStatusColor(attrs.status).color,
                    fontWeight: 600,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Customer</MobileDetailLabel>
                <MobileDetailValue>{attrs.customer?.full_name || "--"}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Phone</MobileDetailLabel>
                <MobileDetailValue>{attrs.customer?.phone_number || "--"}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Service</MobileDetailLabel>
                <MobileDetailValue>{attrs.mobile_service?.name || "--"}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Store</MobileDetailLabel>
                <MobileDetailValue>{attrs.store?.name || "--"}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Pickup Type</MobileDetailLabel>
                <MobileDetailValue>{this.formatMobileRequestStatus(attrs.pickup_type || "--")}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Pickup Scheduled At</MobileDetailLabel>
                <MobileDetailValue>{this.formatMobileRequestDate(attrs.pickup_scheduled_at)}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Delivery Type</MobileDetailLabel>
                <MobileDetailValue>{this.formatMobileRequestStatus(attrs.delivery_type || "--")}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Delivery Scheduled At</MobileDetailLabel>
                <MobileDetailValue>{this.formatMobileRequestDate(attrs.delivery_scheduled_at)}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Created At</MobileDetailLabel>
                <MobileDetailValue>{this.formatMobileRequestDate(attrs.created_at)}</MobileDetailValue>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Assigned Driver</MobileDetailLabel>
                <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                  <MobileDetailValue>
                    {attrs.assigned_driver?.full_name || attrs.assigned_driver?.name || "--"}
                  </MobileDetailValue>
                  {attrs.assigned_driver && (
                    <IconButton
                      data-test-id="driverInfoBtn"
                      size="small"
                      style={{ padding: 2 }}
                      onClick={(event: React.MouseEvent<HTMLElement>) =>
                        this.openContactInfo(event, "Driver", attrs.assigned_driver)
                      }
                    >
                      <PersonOutlineIcon style={{ fontSize: 18, color: "#204B9C" }} />
                    </IconButton>
                  )}
                  {this.state.permissionStatus.changeDriverAccess && (
                    <Button
                      data-test-id="changePickupDriverBtn"
                      size="small"
                      onClick={(event: React.MouseEvent<HTMLElement>) =>
                        this.openDriverMenu(event, "pickup")
                      }
                      style={webStyle.changeDriverBtn}
                    >
                      {attrs.assigned_driver ? "Change" : "Assign"}
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <MobileDetailLabel>Delivery Driver</MobileDetailLabel>
                <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                  <MobileDetailValue>
                    {attrs.delivery_driver?.full_name || "--"}
                  </MobileDetailValue>
                  {attrs.delivery_driver && (
                    <IconButton
                      data-test-id="deliveryDriverInfoBtn"
                      size="small"
                      style={{ padding: 2 }}
                      onClick={(event: React.MouseEvent<HTMLElement>) =>
                        this.openContactInfo(event, "Delivery Driver", attrs.delivery_driver)
                      }
                    >
                      <PersonOutlineIcon style={{ fontSize: 18, color: "#204B9C" }} />
                    </IconButton>
                  )}
                  {this.state.permissionStatus.changeDriverAccess && (
                    <Button
                      data-test-id="changeDeliveryDriverBtn"
                      size="small"
                      onClick={(event: React.MouseEvent<HTMLElement>) =>
                        this.openDriverMenu(event, "delivery")
                      }
                      style={webStyle.changeDriverBtn}
                    >
                      {attrs.delivery_driver ? "Change" : "Assign"}
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <MobileDetailLabel>Notes</MobileDetailLabel>
                <MobileDetailValue>{attrs.notes || "--"}</MobileDetailValue>
              </Grid>
              {attrs.cancellation_reason && (
                <Grid item xs={12}>
                  <MobileDetailLabel>Cancellation Reason</MobileDetailLabel>
                  <MobileDetailValue>{attrs.cancellation_reason}</MobileDetailValue>
                </Grid>
              )}

              {renderAddress("Pickup Address", attrs.pickup_address)}
              {renderAddress("Delivery Address", attrs.delivery_address)}

              {requestOrders.length > 0 && (
                <>
                  <Grid item xs={12}>
                    <Typography style={{ fontFamily: "Montserrat", fontSize: 16, fontWeight: 600, marginTop: 8 }}>
                      {requestOrders.length > 1 ? `Orders (${requestOrders.length})` : "Order Details"}
                    </Typography>
                  </Grid>
                  {requestOrders.length > 1 && ordersSummary && (
                    <Grid item xs={12}>
                      <Box style={{ background: "#F9FAFB", borderRadius: 8, padding: 12 }} data-test-id="mobileRequestOrdersSummary">
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <MobileDetailLabel>Orders</MobileDetailLabel>
                            <MobileDetailValue>{ordersSummary.count ?? requestOrders.length}</MobileDetailValue>
                          </Grid>
                          <Grid item xs={3}>
                            <MobileDetailLabel>Combined Total</MobileDetailLabel>
                            <MobileDetailValue>{ordersSummary.combined_total || "--"}</MobileDetailValue>
                          </Grid>
                          <Grid item xs={3}>
                            <MobileDetailLabel>Payment</MobileDetailLabel>
                            <MobileDetailValue>
                              {ordersSummary.all_paid ? "All Paid" : `${ordersSummary.unpaid_count ?? 0} Unpaid`}
                            </MobileDetailValue>
                          </Grid>
                          <Grid item xs={3}>
                            <MobileDetailLabel>Ready</MobileDetailLabel>
                            <MobileDetailValue>
                              {ordersSummary.all_ready
                                ? "All Ready"
                                : `${ordersSummary.ready_count ?? 0} of ${ordersSummary.count ?? requestOrders.length}`}
                            </MobileDetailValue>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  )}
                  {requestOrders.map((order: any) => renderOrderCard(order))}
                </>
              )}
              {attrs.events && attrs.events.length > 0 && (
                <Grid item xs={12}>
                  <Box
                    data-test-id="toggleEventsBtn"
                    onClick={this.toggleEventsExpanded}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{
                      cursor: "pointer",
                      padding: "12px 16px",
                      background: "#F9FAFB",
                      borderRadius: 8,
                      marginTop: 8,
                    }}
                  >
                    <Typography style={{ fontFamily: "Montserrat", fontSize: 16, fontWeight: 600 }}>
                      Activity Timeline ({attrs.events.length})
                    </Typography>
                    {this.state.eventsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </Box>
                  <Collapse in={this.state.eventsExpanded} timeout="auto" unmountOnExit>
                    <Box style={{ marginTop: 12 }}>
                      {attrs.events.map((event: any, index: number) => {
                        const fromColors = this.getMobileStatusColor(event.from_status);
                        const toColors = this.getMobileStatusColor(event.to_status);
                        return (
                          <Box
                            key={event.id}
                            display="flex"
                            style={{
                              gap: 12,
                              paddingBottom: 16,
                              borderLeft: index === attrs.events.length - 1 ? "none" : "2px solid #E5E7EB",
                              marginLeft: 6,
                              paddingLeft: 16,
                              position: "relative",
                            }}
                          >
                            <Box
                              style={{
                                position: "absolute",
                                left: -7,
                                top: 4,
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                background: toColors.color,
                              }}
                            />
                            <Box flex={1}>
                              <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: "wrap" }}>
                                <Chip
                                  label={this.formatMobileRequestStatus(event.from_status)}
                                  size="small"
                                  style={{ backgroundColor: fromColors.bg, color: fromColors.color, fontWeight: 600 }}
                                />
                                <Typography style={{ fontFamily: "Montserrat", fontSize: 14 }}>→</Typography>
                                <Chip
                                  label={this.formatMobileRequestStatus(event.to_status)}
                                  size="small"
                                  style={{ backgroundColor: toColors.bg, color: toColors.color, fontWeight: 600 }}
                                />
                              </Box>
                              <Typography style={{ fontFamily: "Montserrat", fontSize: 13, color: "#374151", marginTop: 6 }}>
                                {event.actor?.full_name || "Unknown"}
                                {event.actor_role ? ` (${this.formatMobileRequestStatus(event.actor_role)})` : ""}
                                {event.actor?.phone_number ? ` · ${event.actor.phone_number}` : ""}
                              </Typography>
                              <Typography style={{ fontFamily: "Montserrat", fontSize: 12, color: "#6B7280", marginTop: 2 }}>
                                {this.formatMobileRequestDate(event.created_at)}
                              </Typography>
                              {event.notes && (
                                <Typography style={{ fontFamily: "Montserrat", fontSize: 13, color: "#374151", marginTop: 6, fontStyle: "italic" }}>
                                  "{event.notes}"
                                </Typography>
                              )}
                              {event.images && event.images.length > 0 && (
                                <Box display="flex" style={{ gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                                  {event.images.map((img: any) => (
                                    <a
                                      key={img.id}
                                      href={img.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-test-id={`eventImage-${img.id}`}
                                    >
                                      <img
                                        src={img.url}
                                        alt="event evidence"
                                        style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 6, border: "1px solid #E5E7EB" }}
                                      />
                                    </a>
                                  ))}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Collapse>
                </Grid>
              )}
            </Grid>
          ) : (
            <Typography>No data available</Typography>
          )}
        </DialogContent>
        {attrs && attrs.status === "requested" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="acceptMobileRequestBtn"
              variant="contained"
              disabled={this.state.isAcceptingMobileRequest}
              onClick={() => this.acceptMobileRequest(mobileRequestDetailData.id)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              {this.state.isAcceptingMobileRequest ? "Accepting..." : "Accept"}
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "accepted" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="startPickupBtn"
              variant="contained"
              disabled={this.state.isStartingPickup}
              onClick={() => this.startPickup(mobileRequestDetailData.id, attrs.delivery_address)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              {this.state.isStartingPickup ? "Starting..." : "Pick up"}
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "driver_on_the_way_pickup" && (
          <DialogActions style={{ padding: 16, gap: 8, flexWrap: "wrap" }}>
            <Button
              data-test-id="pickedUpBtn"
              variant="contained"
              onClick={() => this.openPickupActionDialog("picked_up")}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              Picked Up
            </Button>
            <Button
              data-test-id="pickupRejectedBtn"
              variant="outlined"
              onClick={() => this.openPickupActionDialog("pickup_rejected")}
              style={{
                borderColor: "#DC2626",
                color: "#DC2626",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              Pickup Rejected
            </Button>
            <Button
              data-test-id="customerUnavailableBtn"
              variant="outlined"
              onClick={() => this.openPickupActionDialog("customer_unavailable")}
              style={{
                borderColor: "#92400E",
                color: "#92400E",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              Customer Unavailable
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "picked_up" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="reachedStoreBtn"
              variant="contained"
              disabled={this.state.isMarkingInStore}
              onClick={() => this.markInStore(mobileRequestDetailData.id)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              {this.state.isMarkingInStore ? "Marking..." : "Reached Store"}
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "in_store" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="createOrderBtn"
              variant="contained"
              onClick={() => this.navigateToOrderCreation(mobileRequestDetailData)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              Create Order
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "delivery_requested" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="acceptDeliveryBtn"
              variant="contained"
              disabled={this.state.isAcceptingDelivery}
              onClick={() => this.acceptDelivery(mobileRequestDetailData.id)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              {this.state.isAcceptingDelivery ? "Accepting..." : "Accept Delivery"}
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "delivery_accepted" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="startDeliveryBtn"
              variant="contained"
              disabled={this.state.isStartingDelivery}
              onClick={() => this.startDelivery(mobileRequestDetailData.id, attrs.delivery_address)}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              {this.state.isStartingDelivery ? "Starting..." : "Start Delivery"}
            </Button>
          </DialogActions>
        )}
        {attrs && attrs.status === "driver_on_the_way_delivery" && (
          <DialogActions style={{ padding: 16 }}>
            <Button
              data-test-id="deliveredBtn"
              variant="contained"
              onClick={() => this.openPickupActionDialog("delivered")}
              style={{
                backgroundColor: "#204B9C",
                color: "#FFF",
                textTransform: "none",
                fontFamily: "Montserrat",
                fontWeight: 600,
                padding: "8px 24px",
              }}
            >
              Delivered
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }

  renderPickupActionDialog() {
    const {
      pickupActionDialogOpen,
      pickupActionType,
      pickupActionNotes,
      pickupActionImages,
      isSubmittingPickupAction,
      mobileRequestDetailData,
    } = this.state;

    if (!pickupActionType) return null;

    const titleMap: { [key: string]: string } = {
      picked_up: "Confirm Pickup",
      pickup_rejected: "Reject Pickup",
      customer_unavailable: "Customer Unavailable",
      delivered: "Confirm Delivery",
    };
    const submitLabelMap: { [key: string]: string } = {
      picked_up: "Confirm Picked Up",
      pickup_rejected: "Submit Rejection",
      customer_unavailable: "Submit",
      delivered: "Confirm Delivered",
    };
    const submitColorMap: { [key: string]: string } = {
      picked_up: "#204B9C",
      pickup_rejected: "#DC2626",
      customer_unavailable: "#92400E",
      delivered: "#204B9C",
    };
    const notesRequired = pickupActionType === "pickup_rejected" || pickupActionType === "customer_unavailable";

    return (
      <Dialog
        open={pickupActionDialogOpen}
        onClose={this.closePickupActionDialog}
        maxWidth="sm"
        fullWidth
        data-test-id="pickupActionDialog"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography style={{ fontFamily: "Montserrat", fontSize: 18, fontWeight: 600 }}>
              {titleMap[pickupActionType]}
            </Typography>
            <IconButton onClick={this.closePickupActionDialog} data-test-id="closePickupActionBtn">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
            <Box>
              <MobileDetailLabel>
                Notes {notesRequired ? "(required)" : "(optional)"}
              </MobileDetailLabel>
              <TextareaAutosize
                data-test-id="pickupActionNotes"
                minRows={4}
                placeholder={notesRequired ? "Please provide a reason..." : "Optional notes"}
                value={pickupActionNotes}
                onChange={(e) => this.setPickupActionNotes(e.target.value)}
                style={{
                  width: "100%",
                  fontFamily: "Montserrat",
                  fontSize: 14,
                  padding: 12,
                  borderRadius: 8,
                  border: "1px solid #E0E0E0",
                  resize: "vertical",
                  boxSizing: "border-box",
                }}
              />
            </Box>
            <Box>
              <MobileDetailLabel>Images (optional)</MobileDetailLabel>
              <input
                data-test-id="pickupActionImages"
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => this.setPickupActionImages(e.target.files)}
                style={{ fontFamily: "Montserrat", fontSize: 14 }}
              />
              {pickupActionImages.length > 0 && (
                <Typography style={{ fontFamily: "Montserrat", fontSize: 12, marginTop: 4, color: "#6B7280" }}>
                  {pickupActionImages.length} file(s) selected
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            data-test-id="cancelPickupActionBtn"
            onClick={this.closePickupActionDialog}
            style={{
              textTransform: "none",
              fontFamily: "Montserrat",
              fontWeight: 600,
              padding: "8px 24px",
            }}
          >
            Cancel
          </Button>
          <Button
            data-test-id="submitPickupActionBtn"
            variant="contained"
            disabled={isSubmittingPickupAction || !mobileRequestDetailData}
            onClick={() => mobileRequestDetailData && this.submitPickupAction(mobileRequestDetailData.id)}
            style={{
              backgroundColor: submitColorMap[pickupActionType],
              color: "#FFF",
              textTransform: "none",
              fontFamily: "Montserrat",
              fontWeight: 600,
              padding: "8px 24px",
            }}
          >
            {isSubmittingPickupAction ? "Submitting..." : submitLabelMap[pickupActionType]}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  mobileRequestsTableHeaderRender(sortingData: ISortingData) {
    return (
      <RowContainer>
        <TableRownew
          className='table-rows header-row compact-row'
          columns={MOBILE_REQUEST_COLUMNS}
        >
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.orderId}
            className='align-item-center'
            sortingKey={'request_number'}
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            sortingData={sortingData}
            content={Strings.placedDate}
            className='align-item-center'
            sortingKey={'created_at'}
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.customer}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={"Store"}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={"Pickup Scheduled"}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={"Service Type"}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={Strings.status}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
          <TableCellnew
            header
            content={"Action"}
            className='align-item-center'
            sortingDisabled
            {...this.sortingProps}
          />
        </TableRownew>
      </RowContainer>
    )
  }

  renderMobileRequestsTableBody(requests: IMobileServiceRequest[]) {
    return (
      <RowContainer>
        {requests.map((rowData: IMobileServiceRequest, index: number) => {
          const attr = rowData.attributes;
          return (
            <React.Fragment key={"mobile-request-" + index}>
              <TableRownew
                className='table-rows compact-row'
                columns={MOBILE_REQUEST_COLUMNS}
                style={{ marginBottom: 8 }}
                data-test-id="mobile-request-row"
              >
                <TableCellnew
                  type='left'
                  style={compactCell}
                  content={
                    <Box style={{ wordBreak: "break-all" }}>
                      {attr.request_number}
                    </Box>
                  }
                />
                <TableCellnew
                  type='middle'
                  style={{ ...compactCell, wordBreak: "break-word" }}
                  content={
                    attr.created_at
                      ? this.handleMomentDateFormat(attr.created_at, "DD/MM/YYYY h:mm A")
                      : "--"
                  }
                />
                <TableCellnew
                  type='middle'
                  style={{ ...compactCell, wordBreak: "break-all" }}
                  content={
                    <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                      <span>{attr.customer?.full_name || "--"}</span>
                      {attr.customer && (
                        <IconButton
                          data-test-id={`customerInfoBtn-${rowData.id}`}
                          size="small"
                          style={{ padding: 2 }}
                          onClick={(event: React.MouseEvent<HTMLElement>) => {
                            event.stopPropagation();
                            this.openContactInfo(event, "Customer", attr.customer);
                          }}
                        >
                          <PersonOutlineIcon style={{ fontSize: 18, color: "#204B9C" }} />
                        </IconButton>
                      )}
                    </Box>
                  }
                />
                <TableCellnew
                  type='middle'
                  style={{ ...compactCell, wordBreak: "break-all" }}
                  content={attr.store?.name || "--"}
                />
                <TableCellnew
                  type='middle'
                  style={{ ...compactCell, wordBreak: "break-word" }}
                  content={
                    attr.pickup_scheduled_at
                      ? this.handleMomentDateFormat(attr.pickup_scheduled_at, "DD/MM/YYYY h:mm A")
                      : "--"
                  }
                />
                <TableCellnew
                  type='middle'
                  style={compactCell}
                  content={attr.mobile_service?.name || "--"}
                />
                <TableCellnew
                  type='middle'
                  style={compactCell}
                  content={
                    <Box style={{ textTransform: "capitalize" }}>
                      {attr.status || "--"}
                    </Box>
                  }
                />
                <TableCellnew
                  type='right'
                  style={compactCell}
                  content={
                    <StatusButton
                      data-test-id={`detailBtn-${rowData.id}`}
                      onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        this.getMobileRequestDetail(rowData.id);
                      }}
                    >
                      Detail
                    </StatusButton>
                  }
                />
              </TableRownew>
            </React.Fragment>
          );
        })}
      </RowContainer>
    )
  }

  renderDriverMenu() {
    const {
      driverMenuAnchor,
      driverMenuLeg,
      assignableDrivers,
      assignableDriversLoading,
      currentDrivers,
      assigningDriverId,
    } = this.state;

    const currentForLeg = currentDrivers[driverMenuLeg];

    return (
      <Popover
        open={Boolean(driverMenuAnchor)}
        anchorEl={driverMenuAnchor}
        onClose={this.closeDriverMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        style={{ zIndex: 1400 }}
        data-test-id="driverMenu"
      >
        <Box style={webStyle.driverMenuBox}>
          <Typography style={webStyle.driverMenuTitle}>
            {driverMenuLeg === "delivery" ? "Delivery driver" : "Pickup driver"}
          </Typography>

          {assignableDriversLoading && (
            <Box display="flex" justifyContent="center" padding={2}>
              <CircularProgress size={22} />
            </Box>
          )}

          {!assignableDriversLoading && assignableDrivers.length === 0 && (
            <Typography style={webStyle.driverMenuEmpty}>
              No drivers available for this store and service.
            </Typography>
          )}

          {!assignableDriversLoading &&
            assignableDrivers.map((driver: IAssignableDriver) => {
              const isCurrent = driver.id === currentForLeg;
              const atCapacity =
                driver.max_concurrent !== null &&
                driver.active_requests >= driver.max_concurrent;
              return (
                <Box
                  key={driver.id}
                  data-test-id={`driverOption-${driver.id}`}
                  onClick={() => !isCurrent && this.assignDriver(driver.id)}
                  style={{
                    ...webStyle.driverOption,
                    background: isCurrent ? "#EEF2FF" : "transparent",
                    cursor: isCurrent ? "default" : "pointer",
                  }}
                >
                  <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                    <PersonOutlineIcon style={{ fontSize: 18, color: "#204B9C" }} />
                    <Box flex={1}>
                      <Typography style={webStyle.driverOptionName}>
                        {driver.full_name || "--"}
                        {isCurrent && (
                          <span style={webStyle.driverCurrentTag}>Current</span>
                        )}
                      </Typography>
                      <Typography style={webStyle.driverOptionMeta}>
                        {driver.phone_number || "--"}
                      </Typography>
                    </Box>
                    {assigningDriverId === driver.id && <CircularProgress size={16} />}
                  </Box>
                  <Box display="flex" style={{ gap: 6, marginTop: 6, flexWrap: "wrap" }}>
                    <span
                      style={{
                        ...webStyle.driverChip,
                        ...(driver.is_available
                          ? webStyle.driverChipGood
                          : webStyle.driverChipMuted),
                      }}
                    >
                      {driver.is_available ? "Available" : "Offline"}
                    </span>
                    {/* Stale location is a warning, not a blocker — the driver may
                        simply not have reported recently. */}
                    <span
                      style={{
                        ...webStyle.driverChip,
                        ...(driver.location_fresh
                          ? webStyle.driverChipGood
                          : webStyle.driverChipWarn),
                      }}
                    >
                      {driver.location_fresh ? "Live location" : "No signal"}
                    </span>
                    <span
                      style={{
                        ...webStyle.driverChip,
                        ...(atCapacity
                          ? webStyle.driverChipWarn
                          : webStyle.driverChipMuted),
                      }}
                    >
                      {driver.active_requests}/{driver.max_concurrent ?? "-"} jobs
                    </span>
                  </Box>
                </Box>
              );
            })}
        </Box>
      </Popover>
    );
  }

  renderContactInfoPopover() {
    const { contactInfoAnchor, contactInfoData, contactInfoTitle } = this.state;
    return (
      <Popover
        open={Boolean(contactInfoAnchor)}
        anchorEl={contactInfoAnchor}
        onClose={this.closeContactInfo}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        // above the detail dialog (MUI modal z-index 1300), since the driver
        // icon that opens this lives inside it
        style={{ zIndex: 1400 }}
        data-test-id="contactInfoPopover"
      >
        <Box style={{ padding: 16, minWidth: 220, fontFamily: "Montserrat" }}>
          <Typography style={{ fontFamily: "Montserrat", fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
            {contactInfoTitle} Info
          </Typography>
          <Box style={{ marginBottom: 6 }}>
            <MobileDetailLabel>Name</MobileDetailLabel>
            <MobileDetailValue>{contactInfoData?.full_name || "--"}</MobileDetailValue>
          </Box>
          <Box style={{ marginBottom: 6 }}>
            <MobileDetailLabel>Contact</MobileDetailLabel>
            <MobileDetailValue>
              {contactInfoData?.phone_number || contactInfoData?.full_phone_number || "--"}
            </MobileDetailValue>
          </Box>
          <Box style={{ marginBottom: contactInfoData?.assigned_at ? 6 : 0 }}>
            <MobileDetailLabel>{contactInfoTitle} ID</MobileDetailLabel>
            <MobileDetailValue>{contactInfoData?.id ?? "--"}</MobileDetailValue>
          </Box>
          {contactInfoData?.assigned_at && (
            <Box>
              <MobileDetailLabel>Assigned At</MobileDetailLabel>
              <MobileDetailValue>
                {this.formatMobileRequestDate(contactInfoData.assigned_at)}
              </MobileDetailValue>
            </Box>
          )}
        </Box>
      </Popover>
    );
  }

  renderTableContainer(isSendToDriver: boolean, rows: IOrderData[], sortingData: ISortingData, isDrawerOpen: boolean) {
    const isComingToStore = this.state.tabId === 0;
    const mobileRequests = this.state.mobileServiceRequests;

    if (isComingToStore) {
      // The tab stays selectable without coming_to_store — it just says so,
      // rather than showing an empty table that looks like there is no work.
      if (!this.state.permissionStatus.comingToStoreAccess) {
        return (
          <Box style={webStyle.noPermissionBox} data-test-id="comingToStoreNoPermission">
            <Typography style={webStyle.noPermissionText}>
              You don't have permission to view Coming to Store.
            </Typography>
          </Box>
        );
      }

      return (
        <OrderTable minWidth={1280} minWidth1024={1280} minWidth1280={1280} minWidth1366={1280}>
          {this.mobileRequestsTableHeaderRender(sortingData)}
          <div>
            {mobileRequests.length > 0 && this.renderMobileRequestsTableBody(mobileRequests)}
          </div>
          {mobileRequests.length === 0 && !this.state.isMobileRequestsLoading && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                fontWeight: 601,
                fontSize: 16,
              }}
            >
              No records found!!
            </div>
          )}
        </OrderTable>
      )
    }

    return (
      <OrderTable minWidth={1280} minWidth1024={1280} minWidth1280={1280} minWidth1366={1280}>
        {!isSendToDriver && this.ordersTableHeaderRender(sortingData)}
        <div>
        {!isSendToDriver && rows.length > 0 && this.renderOrderTableBody(rows)}
        </div>
        {isSendToDriver && this.sendToDriverTableHeaderRender(sortingData, rows)}
        <SendToDriverBody>
        {isSendToDriver && rows.length > 0 && this.renderSendToDriverTableBody(rows)}
        </SendToDriverBody>
        {rows.length === 0 && (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              fontWeight: 601,
              fontSize: 16,
            }}
          >
            No records found!!
          </div>)}
      </OrderTable>
    )
  }

  renderTableSubInfoHeader(isSendToDriver: boolean, rows: IOrderData[]) {
    // if(this.state.isLoadingOrderList) {
    //     <Box sx={{display: isSendToDriver ? "none" : "block", marginBottom:"24px"}}>
    //       <Skeleton animation="wave" variant="rect" width={"full"} height={51} />

    return (
      rows.length > 0 && (
        <Box
          sx={{
            ...webStyle.summary, flexDirection: { xs: 'column', sm: 'unset' },
            display: isSendToDriver ? "none" : "flex"
          }}
        >
          <div className={"summaryLabel"}>
            <span>
              {Strings.orders}{" "}
              <span
                data-test-id='orderValue'
                style={webStyle.summaryValue}
              >
                : {this.state.orderMetaData.orders}
              </span>
            </span>
          </div>
          <div className={"summaryLabel"}>
            <span>
              {Strings.pieces}{" "}
              <span style={webStyle.summaryValue}>
                : {this.state.orderMetaData.pieces}
              </span>
            </span>
          </div>
          <div className={"summaryLabel"}>
            <span>
              {Strings.value}{" "}
              <span style={webStyle.summaryValue}>
                : {this.state.orderMetaData.currency}{" "}
                {this.state.orderMetaData.total}
              </span>
            </span>
          </div>
          <div className={"summaryLabel"}>
            <span>
              {Strings.unpaidAmount}{" "}
              <span
                data-test-id='unpaidValue'
                style={webStyle.summaryValue}
              >
                : {this.state.orderMetaData.currency}{" "}
                {this.state.orderMetaData.unpaid_amount}
              </span>
            </span>
          </div>
        </Box>
      ) 
    )
  }

  renderAfterPermissionComponent() {
    return (
      <div style={{ minWidth: "200px", margin: "0 12px" }}>
        <AutocompleteSelect
          placeholder="Select branch"
          fieldName={"branch"}
          disableClear
          onChange={(_item: React.ChangeEvent, value: { id: string; option: string }) => {
            this.handleStoreId(value);
            this.handleTabChange(1);
          }}
          handleScroll={this.handelStoreDropdownScroll.bind(this)}
          onBlur={() => this.debouncedStoreSearch("")}
          debouncedFunction={this.debouncedStoreSearch}
          value={this.state.storeId}
          options={this.state.storeList}
          listBoxStyle={{maxHeight: 310}}
        />
      </div>
    )
  }

  renderCustomSnackbar = () => this.state.errorMessage || this.state.snackbarMessage ?
    <Portal>
      <CustomSnackbar
        data-test-id="custom-error-message"
        errorMessage={this.state.errorMessage || this.state.snackbarMessage}
        open
        severity={(this.state.snackBarSeverity as "success") || "error"}
        onClose={this.closeCustomSnackbar}
      />
    </Portal>
      : null
  
  renderDriverReceiptDialog = () => {
    const {driverReceipt, showDriverReceiptConfirmation} = this.state
    if (showDriverReceiptConfirmation) return (
      <ConfirmationDialog 
        title="Print Driver Receipt" 
        open
        displayError={!driverReceipt}
        handleClose={() => this.handleDriverReceiptDialog()}
        customMessage={driverReceipt ? "Do you want the print the driver receipt?" : "Unable to get driver receipt for printing"}
        confirmText="OK"
        handleConfirm={() => this.handleDriverReceiptDialog(Boolean(driverReceipt))}
        dynamic={Boolean(driverReceipt)}
      />
    )
    if (this.state.driverReceipt && !this.state.showDriverReceiptConfirmation) return (
      <PrintModal
        onSubmit={this.handlePrintDriverReceipt}
        onCancel={() => this.handleDriverReceiptDialog()}
        isSendToDriver
      />
    )

    return null;
  }

  renderButtonLoadingText = () => {
    if(this.state.isButtonLoading) {
      return <CircularProgress style={{ width: 16, height: 16, color: "white" }}/>
    } else {
      return "Submit"
    }
  };

  // Customizable Area End

  render() {
    // Customizable Area Start
    const { sortingData } = this.state;
    const rows = [...this.state.ordersList];
    const CustomMenuProps: Partial<MenuProps> = {
      PaperProps: {
        style: { maxHeight: 250, maxWidth:"100%" },
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      getContentAnchorEl: null,
    };
    const { tabId, isDrawerOpen } = this.state;

    const isSendToDriver =
      this.state.selectedDropdownvalue === "Send to driver";

    // Customizable Area End
    return (
      // Customizable Area Start
      <Box style={webStyle.mainWrapperOrder}>
          <StyledWrapper className="pageWrapper" data-test-id={configJSON.orderWrapperTest}>
            <CustomLoader loading={this.state.isScanningOrder} />
            {this.renderOrderUnpaidDialog()}
            {this.renderMobileRequestDetailDialog()}
            {this.renderContactInfoPopover()}
            {this.renderDriverMenu()}
            {this.renderPickupActionDialog()}
            <Snackbar
              open={this.state.sendToDriverError.length > 0}
              autoHideDuration={5000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              data-test-id='snackbar'
              key='send-driver-error'
              onClose={this.closeAlertError}
            >
              <Alert
                onClose={() => this.closeAlertError()}
                severity={"error"}
              >
                {this.state.sendToDriverError}
              </Alert>
            </Snackbar>
            { this.renderDriverReceiptDialog() }
            {this.state.orderToPrint && (
              <PrintModal
                onSubmit={this.handleSubmitPrintDialog}
                onCancel={() => this.closePrinterDialog()}
              />
            )}
            <Box className="pageWrapper" data-test-id='table-container-box'>
              <Box>
                {this.renderCustomSnackbar()}
                <Box textAlign="end">
                  <BarcodesScanner 
                    openDialog={!this.state.orderDetailPopup} 
                    navigation={this.props.navigation} 
                    id=""
                    onSubmit={this.scanOrder}
                    loading={this.state.isScanningOrder}
                  />
                </Box>
                
                <StyledAppBar position='static' style={{ margin: "0",display:'none' }}>
                  <Tabs
                    data-test-id={configJSON.tabOrderTypeID}
                    value={this.state.selectedTab}
                    onChange={this.handleTabSeletion}
                    centered
                    className="typeTabs"
                  >
                    {[configJSON.plantCleaningTxt].map(
                      (data) => {
                        return (
                          <CustomTypeTab
                            label={data}
                            value={data}
                            key={data}
                          />
                        );
                      }
                    )}
                  </Tabs>
                </StyledAppBar>
              </Box>
              <TabWrapper>
                <div className="pageHeaderOrder">
                  {!isSendToDriver
                    ? [
                      configJSON.OrdersTab.orders,
                      configJSON.OrdersTab.store,
                      configJSON.OrdersTab.cleaning,
                      configJSON.OrdersTab.ready,
                      configJSON.OrdersTab.delivered,
                      configJSON.OrdersTab.deadstock,
                      configJSON.OrdersTab.cancelled
                    ][tabId]
                    : `${Strings.sendToDriver}`}
                </div>

                {!isSendToDriver && (
                  <TabContainer isDrawerOpen={this.state.isDrawerOpen}>
                    <Paper style={webStyle.tabbingSection}>
                      <CustomTabs
                        className={"CustomTabsStyle"}
                        data-test-id='tabGroup'
                        value={this.state.tabId}
                        onChange={(_event: React.ChangeEvent, value: number) => {
                          this.handleTabChange(value);
                        }}
                        variant={this.handleStatusScroll(this.state.isDrawerOpen)}
                        scrollButtons="on"
                        indicatorColor='primary'
                        textColor='primary'
                        aria-label='icon label tabs example'
                        TabIndicatorProps={{ style: { display: "none" } }}
                      >
                        <CustomTab
                          className={"customTabStyle"}
                          label='Coming to Store'
                          value={0}
                        />
                        <CustomTab value={1} data-test-id="storeTab" className={"customTabStyle"} label='Store' />
                        <CustomTab value={2} className={"customTabStyle"} label='Cleaning' />
                        <CustomTab value={3} className={"customTabStyle"} label='Ready' />
                        <CustomTab value={4} className={"customTabStyle"} label='Delivered' />
                        <CustomTab value={5} className={"customTabStyle"} label='Deadstock' />
                        <CustomTab value={6} className={"customTabStyle"} label='Cancelled' />
                      </CustomTabs>
                    </Paper>
                  </TabContainer>
                )}
                <div className={"head2-3rd-section"}>
                  <div className={"actionSelect"}>
                    <FormControl
                      variant='outlined'
                      style={webStyle.formControl}
                    >
                      <StyledSelect
                        value={this.state.selectedDropdownvalue}
                        renderValue={() =>
                          this.state.dropDownList.find(
                            (option: Option) =>
                              option.value === this.state.selectedDropdownvalue
                          )?.label || "Action"
                        }
                        data-test-id='action'
                        onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                          this.handleDropDownSelect(event);
                        }}
                        displayEmpty={true}
                        variant='outlined'
                        MenuProps={CustomMenuProps}
                      >
                        <StyledMenuItem value=''>
                          <em>Action</em>
                        </StyledMenuItem>
                        {this.state.dropDownList.map(
                          (option) =>
                            (option.tabId === this.state.tabId && option.permission) && (
                              <StyledMenuItem value={option.value}>
                                {option.label}
                              </StyledMenuItem>
                            )
                        )}
                      </StyledSelect>
                    </FormControl>
                  </div>
                  <div style={webStyle.headerButtonPartAccountOrder}>
                    <FilterBtn
                      data-test-id='filterButton'
                      onClick={(event) => {
                        this.openFilterPopover(event);
                        this.handleCallSectionListAPI()
                        this.handleCallPaymentListAPI()
                      }}
                      className={sortStringCondition(
                        this.state.isAppliedFilter,
                        "active-border",
                        ""
                      )}
                    >
                      <FilterIcon color={this.handleReturnColorType()} />
                      {renderBaseOnConditions(
                        this.state.isAppliedFilter,
                        <div className="filterActiveIcon"></div>,
                        <></>
                      )}
                    </FilterBtn>
                    <FilterPopover
                      onClearFilter={() => {
                        this.clearFilterPopOver();
                      }}
                      onAutoCompleteChange={(title: string, value: string) => {
                        this.filterAutoCompleteSuggestionListByTitle(title, value);
                      }}
                      onClose={() => {
                        this.closeFilterPopover();
                      }}
                      anchor={this.state.filterAnchor}
                      onFilterChange={this.handleFilterChange}
                      refreshFilterState={(filters: IFilter[]) =>
                        this.handleSetStateFilter(filters)
                      }
                      filters={this.state.filters}
                    />
                  </div>
                </div>
              </TabWrapper>
              {this.renderTableSubInfoHeader(isSendToDriver, rows)}
              
              <Box style={{overflowY: "auto",flex: "1 1 0", display: 'flex'}}  data-test-id='table-container'>
              {this.renderTableContainer(isSendToDriver, rows, sortingData, isDrawerOpen)}
              </Box>

              {rows.length > 0 && (
                <TablePagination
                  data-test-id='pagination'
                  rowsPerPageOptions={[10, 20, 30]}
                  component='div'
                  count={this.state.orderMetaData?.total_count || 1}
                  rowsPerPage={this.state.pageSize}
                  page={this.state.page - 1}
                  onRowsPerPageChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                    this.handleTableRowsPerPage(event)
                  }}
                  onPageChange={(event, page) => {
                    this.handlePageChange(page + 1);
                  }}
                />
              )}
            </Box>

            {isSendToDriver && (
              <div
                className="sendToDriverActions"
              >
                <FormControl variant='outlined' style={webStyle.formControl} className="selectBox">
                  <StyledSelect
                    renderValue={(value) =>
                      this.state.driverList.find(
                        (option: Option) =>
                          option.value === this.state.selectedDriver
                      )?.label || "Send To"
                    }
                    data-test-id='sendTo'
                    className={"sentToDropdwon"}
                    displayEmpty={true}
                    style={webStyle.inputField}
                    variant='outlined'
                    onChange={(event) =>
                      this.handleSelectedDriver(event)
                    }
                    MenuProps={CustomMenuProps}
                  >
                    <StyledMenuItem value=''>
                      <em>Send To</em>
                    </StyledMenuItem>
                    {this.state.driverList.map((option) => (
                      <StyledMenuItem value={option.value} key={option.value}>
                        {option.label}
                      </StyledMenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>

                <BottomContainer>
                  <button
                    data-test-id='btn-cancel'
                    className='cancel'
                    onClick={() => this.handleCancel()}
                  >
                    Cancel
                  </button>
                  <button
                    data-test-id='btn-submit'
                    className='add'
                    onClick={() => this.onClickSendToDriverSubmit()}
                  >
                    { this.renderButtonLoadingText() }
                  </button>
                </BottomContainer>
              </div>
            )}
            {this.checkSelectDropdownValue() && (
              <div
                style={{
                  width: 254,
                  marginLeft: 48,
                  paddingTop: 32,
                }}
              >
                <BottomContainer style={{ paddingTop: 23, paddingBottom: 48 }}>
                  <button
                    data-test-id='btn-cancel-clean'
                    className='cancel'
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleCancel()}
                  >
                    Cancel
                  </button>
                  <button
                    data-test-id='btn-submit-clean'
                    className='add'
                    style={{ cursor: "pointer" }}
                    onClick={() => this.onClickSendToCleanSubmit()}
                  >
                    {this.renderButtonText()}
                  </button>
                </BottomContainer>
                <br />
              </div>
            )}
            {this.renderCreditNoteDialog()}
          </StyledWrapper>

        {this.state.orderDetailPopup && (
          <OrderDetailsPage
            onRefetchOrderList={() => this.getOrdersList()}
            onClose={this.onCloseDetailsScreen.bind(this)}
            storeId={String(this.state.storeId)}
            onMoveToStore={() => this.handleTabChange(1)}
            orderData={this.state.orderData}
            isNewOrderDetailsModal={this.state.selectedTab === configJSON.plantCleaningTxt ? false : true}
          />
        )}
         {renderBaseOnConditions(
            this.state.paymentModalVisible,
              <PaymentModal
                fromUnpaid={true}
                data-test-id='paymentmodal'
                onPromoCodeApply={() => this.getOrder()}
                open={this.state.paymentModalVisible}
                handleClose={this.handlePaymentModalClose}
                totalItems={this.state.order?.attributes?.order_items.length || 0}
                taxPercentage={5}
                onPaymentDone={this.handlePaymentDone}
                customerId={this.state.customerId}
                order={this.state.order?.attributes}
                paymentClicked={this.state.paymentClicked} 
                goldenPointList={[]}            />,
            <></>
          )}

          {renderBaseOnConditions(
            this.state.showDirectPaymentModal,
            <PaymentModal
              fromUnpaid={true}
              data-test-id='paymentmodal1'
              onPromoCodeApply={() => this.getOrderDetail()}
              open={this.state.showDirectPaymentModal}
              handleClose={this.handleSinglePaymentClose}
              totalItems={this.state.selectedOrder?.attributes?.order_items.length || 0}
              taxPercentage={this.formatTaxPercentage()}
              onPaymentDone={this.handleSinglePaymentDone}
              customerId={String(this.state.selectedOrder?.attributes.account_id)}
              order={this.state.selectedOrder?.attributes as unknown as IOrder}
              paymentClicked={this.state.ispaymentClicked} 
              goldenPointList={[]}          />,
            <></>
          )}

        {/* Notes Dialog */}
        <Dialog
          open={this.state.notesDialogOpen}
          onClose={this.handleCloseNotesDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Add/Edit Notes</DialogTitle>
          <DialogContent>
            {/* Display existing notes as numbered list */}
            {(() => {
              const { currentOrderIdForNotes } = this.state;
              if (!currentOrderIdForNotes) return null;
              
              const currentOrder = this.state.ordersList.find(order => order.id === currentOrderIdForNotes);
              const existingNotes = currentOrder?.attributes?.notes;
              
              if (existingNotes && existingNotes.trim() !== '') {
                const notesList = existingNotes.split('|').filter(note => note.trim() !== '');
                return (
                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="subtitle2" style={{ marginBottom: '8px', fontWeight: 600 }}>
                      Existing Notes:
                    </Typography>
                    <div style={{
                      backgroundColor: '#f5f5f5',
                      padding: '12px',
                      borderRadius: '4px',
                      border: '1px solid #e0e0e0'
                    }}>
                      {notesList.map((note, index) => (
                        <Typography key={index} variant="body2" style={{ margin: '4px 0' }}>
                          {index + 1}. {note.trim()}
                        </Typography>
                      ))}
                    </div>
                  </div>
                );
              }
              return null;
            })()}
            
            <Typography variant="body2" style={{ marginBottom: '8px', color: '#666' }}>
              Add new note (will be added as note #{(() => {
                const { currentOrderIdForNotes } = this.state;
                if (!currentOrderIdForNotes) return 1;
                
                const currentOrder = this.state.ordersList.find(order => order.id === currentOrderIdForNotes);
                const existingNotes = currentOrder?.attributes?.notes;
                
                if (existingNotes && existingNotes.trim() !== '') {
                  const notesList = existingNotes.split('|').filter(note => note.trim() !== '');
                  return notesList.length + 1;
                }
                return 1;
              })()}):
            </Typography>
            <TextareaAutosize
              style={{
                width: '100%',
                minHeight: '80px',
                padding: '12px',
                fontSize: '14px',
                fontFamily: 'Montserrat',
                border: '1px solid #ccc',
                borderRadius: '4px',
                resize: 'vertical'
              }}
              placeholder="Enter new note here..."
              value={this.state.tempNotes}
              onChange={this.handleNotesChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseNotesDialog}
              color="default"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleSaveNotes}
              color="primary"
              variant="contained"
              disabled={this.state.isUpdatingNotes}
            >
              {this.state.isUpdatingNotes ? (
                <CircularProgress size={20} style={{ color: 'white' }} />
              ) : (
                'Save'
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
export const webStyle = {
  table: {
    minWidth: 700,
  },
  changeDriverBtn: {
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 600,
    color: "#204B9C",
    textTransform: "none" as const,
    minWidth: "auto",
    padding: "0 6px",
  },
  driverMenuBox: {
    padding: 12,
    minWidth: 300,
    maxHeight: 380,
    overflowY: "auto" as const,
    fontFamily: "Montserrat",
  },
  driverMenuTitle: {
    fontFamily: "Montserrat",
    fontSize: 13,
    fontWeight: 600,
    color: "#64748B",
    marginBottom: 8,
  },
  driverMenuEmpty: {
    fontFamily: "Montserrat",
    fontSize: 13,
    color: "#64748B",
    padding: 8,
  },
  driverOption: {
    borderRadius: 8,
    border: "1px solid #ECECEC",
    padding: "8px 10px",
    marginBottom: 8,
  },
  driverOptionName: {
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    color: "#1A1A1A",
  },
  driverOptionMeta: {
    fontFamily: "Montserrat",
    fontSize: 12,
    color: "#64748B",
  },
  driverCurrentTag: {
    fontFamily: "Montserrat",
    fontSize: 11,
    fontWeight: 600,
    color: "#204B9C",
    marginLeft: 6,
  },
  driverChip: {
    fontFamily: "Montserrat",
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 999,
    padding: "2px 8px",
  },
  driverChipGood: { background: "#D1FAE5", color: "#065F46" },
  driverChipWarn: { background: "#FEF3C7", color: "#92400E" },
  driverChipMuted: { background: "#F3F4F6", color: "#4B5563" },
  noPermissionBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "64px 24px",
    border: "1px solid #ECECEC",
    borderRadius: 12,
  },
  noPermissionText: {
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: 500,
    color: "#64748B",
  },
  mainWrapperOrder: {
    fontFamily: "Montserrat",
  },
  headerWrapperOrder: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 32,
    alignItems: "center",
  },

  headerButtonPartAccountOrder: {
    display: "flex",
  },
  
  summary: {
    display: "flex",
    padding: "16px 32px",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "12px",
    background: "#EC4E20",
    marginBottom: "24px",
    justifyContent: "space-between"
  },
  summaryLabel: {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    display: "inlineBlock",
  },
  summaryValue: {
    fontWeight: 600,
  },
  detailBtn: {
    color: "#204B9C",
    textDecoration: "underline",
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "12px",
    cursor: "pointer",
  },
  cellText: {
    fontSize: "12px",
    fontWeight: 500,
    paddingTop: "16px",
  },
  customTab: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    margin: "2px",
  },
  tabbingSection: {
    backgroundColor: "#f8fafc",
    borderRadius: "40px",
    margin: "0 auto",
    boxShadow: "none",
  },
  inputField: {
    width: "100%",
    height: "56px",
    fontFamily: "Montserrat !important",
  },
  formControl: {
    width: "100%",
    borderRadius: "8px",
    fontFamily: "Montserrat",
  },
  unPaidDialogPara: {
    maxWidth: "428px",
    margin: "auto"
  },
  IconImgGroup: {
    display: "flex",
    justifyContent: "center",
    gap: 16,
    alignItems:"center"
  },
  ButtonGroup: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap"
  },
  StatusSpan: {
    textTransform: "capitalize" as const,
  }
};

export const TabWrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 0",
  // marginBottom:"22px",
  position: "sticky",
  top: "0px",
  background: "white",
  zIndex: 1,
  "& .pageHeaderOrder": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    "@media only screen and (max-width: 1280px)": {
      fontSize: "21px",
    },
    "@media only screen and (max-width: 1024px)": {
      fontSize: "17px",
    }
  },
});

export const StyledImageCheckbox = styled("img")({
  padding: 0,
  cursor: "pointer",
  border: "1px solid #64748B",
  borderRadius: "6px"
});

export const StyledMenuItem = styled(MenuItem)({
  "&.MuiListItem-button:hover": {
    backgroundColor: "#204B9C",
    color: "white",
  },
  "@media only screen and (max-width: 1280px)": {
    fontSize: 14,
  },
});

export const TabContainer = styled('div')((props: StyledComponentProps & {isDrawerOpen : boolean}) => {
  let containerWidth = '';

  if (props.isDrawerOpen && window.innerWidth <= 1366) {
      containerWidth = "550px";
  } else if (props.isDrawerOpen && window.innerWidth <= 1560) {
      containerWidth = "610px";
  }

  const overflowUnset = {
    overflow: 'unset',
  }
  return {
    overflowX: 'auto',
    "@media only screen and (max-width: 800px)": {
      overflowX: 'unset',
    },
    "@media only screen and (min-width: 1000px)": {
      padding: '0 16px',
    },
    '& .MuiTabs-root': {...overflowUnset },
    '& .MuiTabs-scroller': {
      overflowX: 'unset !important' as 'unset',
      ...overflowUnset,
    },
    "& .MuiTab-root": {
      minWidth: "unset",
      flexGrow: "unset",
      flexBasis: "unset",
      whiteSpace: "nowrap",
      ...overflowUnset
    },
    "& .MuiTabs-flexContainer": {
      gap: 4,
      width: containerWidth,
      "@media only screen and (max-width: 1024px)": {
        width: "385px"
      }
    },
  };
});


const MobileDetailLabel = styled(Typography)({
  fontFamily: "Montserrat",
  fontWeight: 600,
  fontSize: 13,
  color: "#64748B",
  marginBottom: 4,
});

const MobileDetailValue = styled(Typography)({
  fontFamily: "Montserrat",
  fontSize: 15,
  color: "#1A1A1A",
});

const StatusButton = styled("button")({
  padding: "4px 10px",
  background: "rgba(32, 75, 156, 0.1)",
  color: "#204B9C",
  outline: "none",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontFamily: '"Montserrat", sans-serif',
  fontSize: 13,
  fontWeight: 600,
  minWidth:"40%",
  '@media (max-width: 600px)': {
    padding: "3px 8px",
    fontSize: 11,
  },
});

export const StyledSelect = styled(Select)({
  ...webStyle.inputField,
  "& .MuiSelect-select": {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: 16,
    fontWeight: 500,
    textAlign: "left",
    lineHeight: "24px",
    "@media only screen and (max-width: 1280px)": {
      fontSize: 14,
    },
    "@media only screen and (max-width: 1024px)": {
      fontSize: "12px",
    }
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ECECEC",
  },
  "@media only screen and (max-width: 1280px)": {
    height: "48px",
  },
  "@media only screen and (max-width: 1024px)": {
    height: "40px",
  }
});

const SelectAllContainer = styled("div")({
  gap: 16,
  marginLeft: 9,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .PrivateSwitchBase-root-58": {
    padding: 0,
  },
});

const FilterButton = styled("button")({
  padding: 10,
  minWidth: 56,
  display: "flex",
  borderRadius: 8,
  cursor: "pointer",
  alignItems: "center",
  backgroundColor: "white",
  justifyContent: "center",
  border: "1px solid #ECECEC"
});

export const CustomTypeTab = styled(Tab)({
  textTransform: "none",
  fontFamily: "Montserrat",
  fontSize: "16px",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "14px",
    minHeight: "0px"
  }
});

const StyledAppBar = withStyles({
  root: {
    color: colors().darkliver,
    marginTop: "10px",
    backgroundColor: colors().white,
    borderBottom: `1px solid ${colors().lightborder}`,
    boxShadow: "none",
    "& .Mui-selected": {
      color: colors().cyancobaltblue,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: `${colors().cyancobaltblue} !important`,
    },
    "& .MuiPaper-elevation": {
      boxShadow: "none",
    },
  },
})(AppBar);

export const FilterBtn = styled('div')({
  position: "relative",
  cursor: "pointer",
  background: "#FFFFFF",
  height: "56px",
  color: "#4d4d4d",
  width: "56px",
  fontSize: "24px",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid #ECECEC",
  "&.active-border": {
    border: "1px solid #204B9C",
  },
  "& .filterActiveIcon": {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    minWidth: "15px",
    background: "#204B9C",
    minHeight: "15px",
    borderRadius: "50%"
  },
  "@media only screen and (max-width: 1280px)": {
    height: "48px",
    width: "48px",
  },
  "@media only screen and (max-width: 1024px)": {
    height: "40px",
    width: "40px"
  }
});

const StatusDiv = styled("div")({
  padding: "4px 10px",
  outline: "none",
  border: "none",
  borderRadius: "6px",
  marginLeft: -20,
  display: 'flex',
  alignItems: 'center',
  zIndex: 0
});

const CustomRadioUnpaid = styled(Radio)({
  '& .MuiIconButton-label': {
    color: '#DC2626 !important',
    padding: 0
  },
})
const CustomRadioPaid = styled(Radio)({
  '& .MuiIconButton-label': {
    color: '#059669 !important',
    padding: 0
  },
})

const StyledWrapper = styled('div')({
  "& .orderIdColumn": {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    minHeight: '163px',
    alignItems:"flex-start"
  },
  "& .labelPaidUnpaid": {
    cursor: "pointer",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: 13,
    fontWeight: 500,
  },
  "& .customTabStyle": {
    ...webStyle.customTab,
    "@media only screen and (max-width: 1280px)": {
      fontSize: "14px",
      padding: "0 8px",
      minHeight: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      fontSize: "12px",
      padding: "0 5px",
      minHeight: "28px"
    }
  },
  "& .CustomTabsStyle": {
    "& .MuiTabs-scroller": {
      display:"flex"
    },
    "& .MuiTabs-scrollButtons": {
      background:"#F8FAFC",
      width: 20
    },
    "@media only screen and (max-width: 1024px)": {
      width:"400px"
    }
  },
  "& .head2-3rd-section": {
    display: "flex",
    gap: 24,
    "@media only screen and (max-width: 1280px)": {
      gap: 18,
    },
    "@media only screen and (max-width: 1024px)": {
      gap: 12,
    }
  },
  "& .actionSelect": {
    minWidth: 180,
    "@media only screen and (max-width: 1366px)": {
      minWidth: 170,
    },
    "@media only screen and (max-width: 1280px)": {
      minWidth: 160,
    },
    "@media only screen and (max-width: 1024px)": {
      minWidth: 140,
    }
  },
  "& .typeTabs": {
    "& .MuiTabs-indicator": {
      "@media only screen and (max-width: 1024px)": {
        height: "1px"
      }
    },
    "@media only screen and (max-width: 1024px)": {
      minHeight: "0"
    }
  },
  "& .summaryLabel": {
    ...webStyle.summaryLabel,
    "@media only screen and (max-width: 1024px)": {
      fontSize: "14px"
    }
  },
  "& .detailsBtn": {
    ...webStyle.detailBtn,
    "@media only screen and (max-width: 1024px)": {
      fontSize: "14px"
    }
  },
  "& .statusColumnAction": {
    ...webStyle.IconImgGroup,
    display:"flex",
    "@media only screen and (max-width: 1024px)": {
      gap: "8px"
    }
  },
  "& .align-item-center": {
    alignItems: "center",
  },
  "& .table-rows > div": {
    fontSize: "16px",
    textAlign: "left",
    minHeight: "168px",
    textTransform: "capitalize",
    fontWeight: "400 !important",
    "@media only screen and (max-width: 1366px)": {
      minHeight: "163px"
    },
    "@media only screen and (max-width: 1280px)": {
      minHeight: "158px"
    },
    "@media only screen and (max-width: 1024px)": {
      minHeight: "148px",
      fontSize: "12px"
    }
  },
  "& .table-rows.compact-row > div": {
    minHeight: "44px",
    "@media only screen and (max-width: 1366px)": {
      minHeight: "42px"
    },
    "@media only screen and (max-width: 1280px)": {
      minHeight: "40px"
    },
    "@media only screen and (max-width: 1024px)": {
      minHeight: "36px"
    }
  },
  "& .columnContainer": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "height": "100%",
    "paddingBottom": "8px",
    "& .total": {
      display:"inline-block",
      overflow:"hidden",
      whiteSpace:"nowrap"
     },
  },
  "& .pcsCell": {
    padding:"1rem 1rem 1rem 2rem",
    "@media only screen and (max-width: 1024px)": {
     padding:"1rem"
    }
  },
  "& .sendToDriverActions": {
    display: "flex",
    justifyContent:"space-between",
    gap: 20,
    alignItems: "center",
    position: "sticky",
    bottom: 0,
    width: "100%",
    padding: "16px 0 16px 16px",
    background: colors().ghostwhite,
    "& > div": {
      paddingTop: "0 !important"
    },
    "& .selectBox": {
      width:"300px !important"
    }
  },
  "& .credit-note-button": {
    marginTop:"5px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    "& button": {
      gap: 6,
      border: 0,
      cursor: "pointer",
      display: "flex",
      padding: "6px 10px",
      textAlign: "center",
      alignItems: "center",
      borderRadius: "6px",
      color: colors().cyancobaltblue,
      backgroundColor: colors().cyancobaltblue + "1A",
      fontWeight: 600,
      "& span": {
        "@media only screen and (max-width: 1024px)": {
          fontSize: "11px"
         }
      },
    },
  },
  "& .credit-note-show-button": {
    display: "flex",
    width: "100%",
    alignItems: "center",
    "& button": {
      display: "flex",
      gap: 4,
      cursor: "pointer",
      border: 0,
      padding: "6px 10px",
      textAlign: "center",
      borderRadius: "6px",
      backgroundColor: colors().cyancobaltblue + "1A",
      color: "gray",
      alignItems: "center",
      fontWeight: 600,
      "& span": {
        "@media only screen and (max-width: 1024px)": {
          fontSize: "11px"
         }
      },
    },
  },
})

const SendToDriverBody = styled("div")({
  maxHeight: "calc(100vh - 425px)",
  overflow:"auto",
  "@media only screen and (max-width: 1280)": {
    maxHeight: "calc(100vh - 410px)",
  },
  "@media only screen and (max-width: 1366px)": {
    maxHeight: "calc(100vh - 420px)",
  },
  "@media only screen and (max-width: 1024px)": {
    maxHeight: "calc(100vh - 350px)",
  },
})

// Customizable Area End
